<template>
  <a-config-provider :locale="zhCN"
                     :theme="{algorithm: app.active.theme.dark ? theme.darkAlgorithm : theme.defaultAlgorithm}">
    <router-view/>
  </a-config-provider>
  <div id="captcha"/>
</template>

<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import {printWelcome} from "@/lib/util";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn'
import {theme} from "ant-design-vue";
import {watchEffect} from "vue";
import {GlobalToken} from "ant-design-vue/es/theme";
import app from "@/model/app";

dayjs.locale('zh-cn')
printWelcome()

/**
 * 驼峰转中划线函数
 * colorPrimary -> color-primary
 */
const toKebabCase = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

// 获取当前的 Token (包含 a-config-provider 注入的自定义配置)
const {token} = theme.useToken();
token.value.controlInteractiveSize = 20

const updateCSSVariables = (tokens: GlobalToken) => {
  const root = document.documentElement;

  // 需要排除添加 'px' 单位的特殊属性
  const unitlessKeys = ['zIndex', 'opacity', 'fontWeight', 'lineHeight', 'flex', 'order'];

  Object.entries(tokens).forEach(([key, value]) => {
    // 只处理字符串和数字
    if (typeof value === 'string' || typeof value === 'number') {
      const cssVarName = `--ant-${toKebabCase(key)}`;
      let cssValue: string | number = value;

      // 为数值类型自动添加 px 单位，除非它在排除名单中
      if (
          typeof value === 'number' &&
          !unitlessKeys.some(k => key.toLowerCase().includes(k.toLowerCase()))
      ) {
        cssValue = `${value}px`;
      }

      root.style.setProperty(cssVarName, cssValue.toString());
    }
  });
  root.style.setProperty('--color-bg-secondary', app.active.theme.dark ? '#191919' : '#e2e6f3')
  root.style.setProperty('--color-editor-bg', app.active.theme.dark ? '#191919' : '#f5f5f5')
  root.style.setProperty('--color-bg-hover', app.active.theme.dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)')
};

// 监听 Token 变化（如中英文切换、暗黑模式切换、主题色更改）
watchEffect(() => {
  if (token.value) {
    updateCSSVariables(token.value);
  }
});

</script>

<style lang="sass">
body
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif

#app
  height: 100vh
  min-width: 1280px
  display: flex
  flex-direction: column
  position: relative
  background-color: var(--color-bg-secondary)
  color: var(--ant-color-text-base)

</style>